





























































































































































import * as _ from 'lodash'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

import confirmDialog from '@/dialog/Confirm.vue'
import dateField from '@/form/Datefield.vue'
import miniFabButton from '@/elements/MiniFabButton.vue'
import selectField from '@/form/Selectfield.vue'
import textField from '@/form/Textfield.vue'

export default
  name: 'Activities'
  data: () ->
    start: moment().startOf('year').format('YYYY-MM-DD')
    end: moment().endOf('year').format('YYYY-MM-DD')
    new_activity: null
    edit_activity: null
    edit_uid: null
    show:
      confirm: false
      message: ''
      action: null
    types: [
      { label: null, value: null }
    ]
    sort_key: 'name'
    sort_order: 'asc'

  components:
    'v-dialog-confirm': confirmDialog
    'v-datefield': dateField
    'v-selectfield': selectField
    'v-textfield': textField
    'v-fab-button': miniFabButton

  methods:
    cancel: ->
      @$store.dispatch 'showDialog', null
      @show.confirm = false

    addActivity: () ->
      await @$store.dispatch 'addActivity', @new_activity
      @reset()

    updateActivity: (activity) ->
      await @$store.dispatch 'updateActivity', @edit_activity
      @edit_uid = null
      @edit_activity = null

    editActivity: (activity) ->
      @edit_activity = _.cloneDeep activity
      @edit_uid = activity.uid

    deleteActivity: (activity) ->
      @show.message = 'Säker på att du vill radera "' + activity.name + '"?'
      @show.action = () =>
        @removeActivity(activity)
      @$store.dispatch 'showDialog', 'confirm'

    removeActivity: (activity) ->
      @$store.dispatch 'deleteActivity', activity
      @$store.dispatch 'showDialog', null
      @show.confirm = false

    escapeKeyListener: (evt) ->
      if evt.keyCode == 27 then @reset()

    reset: ->
      @new_activity =
        uid: null
        activity_type_uid: if @types.length > 0 then @types[0].value else null
        name: null
        start: moment().format('YYYY-MM-DD')
        end: null

      @edit_uid = null

      console.log @new_activity.activity_type_uid

    setupTypes: ->
        @types = []
        for type in @activity_types.getEmbeds 'activity_type'
          @types.push
              label: type.name
              value: type.uid

    toggleSortOrder: ->
      if @sort_order == 'asc' then @sort_order ='desc' else @sort_order ='asc'
      console.log @sort_order

    sort: (key) ->
      if @sort_key == key
        @toggleSortOrder()
        return

      @sort_key = key
      @sort_order = 'asc'

    sortClass: (key) ->
      if key == @sort_key
        if @sort_order == 'asc'
          'mdl-data-table__header--sorted-ascending': true
        else
          'mdl-data-table__header--sorted-descending': true

    sortedActivities: () ->
      acts= []
      for activity in @activities.getEmbeds('activities')
        act = _.cloneDeep activity
        act.activity_type_label = activity.getEmbed('activity_type').name
        acts.push act

      _.orderBy acts, [(item) => item[@sort_key]?.toLowerCase()], [@sort_order]

    fetchActivities: ->
      await @$store.dispatch 'getActivities', { start: @start, end: @end }

  created: ->
    @reset()

    if !@are_loaded.resources then await @$store.dispatch 'getServices'
    if !@are_loaded.activities then await @$store.dispatch 'getActivities', { start: @start, end: @end }
    if !@are_loaded.activity_types then await @$store.dispatch 'getActivityTypes'
    @setupTypes()
    @reset()
    document.addEventListener 'keyup', @escapeKeyListener

  mounted: ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ->
    componentHandler.downgradeElements @$el

  destroyed: ->
    document.removeEventListener 'keyup', @escapeKeyListener

  watch:
    'start': () ->
      @fetchActivities()
    'end': () ->
      @fetchActivities()

  computed: {
    mapState([
      'are_loaded'
      'activity_types'
      'activities'
    ])...
  }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Activities.vue